import { ColorsEnum } from "../../../../../core/et3-theme/colors";

const ALPHA_CHIP_SOFT = "1F";

export const SUMMARY_HEADER_WIDTH = 1500;
export const SUMMARY_HEADER_PADDING_X = 18;
export const SUMMARY_HEADER_PADDING_Y = 14;
export const SUMMARY_HEADER_ACCENT_WIDTH = 3;
export const SUMMARY_HEADER_IDENTITY_HEIGHT = 34;
export const SUMMARY_HEADER_ROW_GAP = 10;
export const SUMMARY_HEADER_ITEM_GAP = 12;
export const SUMMARY_USERNAME_FONT_SIZE = 21;
export const SUMMARY_USER_ID_FONT_SIZE = 13;
export const SUMMARY_USER_ID_PADDING = 7;
export const SUMMARY_USER_ID_RADIUS_CSS = "5px";
export const SUMMARY_CHIP_FONT_SIZE = 11;
export const SUMMARY_CHIP_HEIGHT = 24;
export const SUMMARY_CHIP_PADDING = 9;
export const SUMMARY_CHIP_RADIUS_CSS = "5px";
export const SUMMARY_CHIP_LETTER_SPACING = 0.5;
export const SUMMARY_FACT_FONT_SIZE = 13;
export const SUMMARY_FACTS_GAP_X = 22;
export const SUMMARY_FACTS_GAP_Y = 4;
export const SUMMARY_STICKY_TOP = 0;
export const SUMMARY_STICKY_Z_INDEX = 2;

export const SUMMARY_CHIP_SOFT_CRITICAL = `${ColorsEnum.red}${ALPHA_CHIP_SOFT}`;
export const SUMMARY_CHIP_SOFT_WARNING = `${ColorsEnum.darkOrange}${ALPHA_CHIP_SOFT}`;
export const SUMMARY_CHIP_SOFT_POSITIVE = `${ColorsEnum.green}${ALPHA_CHIP_SOFT}`;
export const SUMMARY_CHIP_SOFT_NEUTRAL = `${ColorsEnum.maastrichtBlue}${ALPHA_CHIP_SOFT}`;

export const SUMMARY_NAV_BUTTON_HEIGHT = 32;
export const SUMMARY_NAV_BUTTON_PADDING = 14;
export const SUMMARY_NAV_BUTTON_FONT_SIZE = 13;
export const SUMMARY_NAV_BUTTON_RADIUS_CSS = "8px";
